// <------------------------ Event Request ------------------------>

import { EventRequestDto } from '@cineamo/api/models/event-request/EventRequestDto.types';

import { ApiResponse } from '@cineamo/api/types/ApiResponse.types';

import { API_URL } from '@/constants/http-constants';

import apiClient from '@/utils/api/cineamoApiClient';

/**
 * This endpoint returns an event request.
 *
 * @example
 * // Get an event request by id:
 * getEventRequestById(1, {...params});
 *
 * @param eventRequestId
 * @returns {ApiResponse<EventRequestDto>}
 */

export async function getEventRequestById(
    eventRequestId: number | string
): Promise<ApiResponse<EventRequestDto> | null> {
    return await apiClient.getOrNull<ApiResponse<EventRequestDto>>(`${API_URL}/event-requests/${eventRequestId}`);
}
